<template>
    <div>
        <div class='item-actions icon-text-buttons flex-container'>
            <p-button type="default" class="stacked flex-child" @click=this.displaysOff>
                <span>{{ $t('display_groups.turn_off_group_displays') }}</span>
            </p-button>
            <p-button type="default" class="stacked flex-child" @click=this.displaysOn>
                <span>{{ $t('display_groups.turn_on_group_displays') }}</span>
            </p-button>
            <p-button type="default" class="stacked flex-child" @click=this.predictionsOff>
                <span>{{ $t('display_groups.turn_off_group_predictions') }}</span>
            </p-button>
            <p-button type="default" class="stacked flex-child" @click=this.predictionsOn>
                <span>{{ $t('display_groups.turn_on_group_predictions') }}</span>
            </p-button>
            <p-button type="default" class="stacked flex-child" @click=this.normalMode>
                <span>{{ $t('display_groups.turn_on_group_normalmode') }}</span>
            </p-button>
            <p-button type="default" class="stacked flex-child" @click=this.announcementsOnlyOn>
                <span>{{ $t('display_groups.announcements_only_on') }}</span>
            </p-button>
            <p-button type="default" class="stacked flex-child" @click=this.sendAnnouncementsToTimetables>
                <span>{{ $t('display_groups.send_announcements_to_timetables') }}</span>
            </p-button>
            <RequestInfo type="save" :ok="OK" :error="ERROR" :loader="loading" />
        </div>
    </div>
</template>
<script>

export default {
    props: {
        item: {
            id: null,
            name: '',
            devices: [],
        }
    },
    data() {
        return {
            itemName: '',
            showRequestResult: false,
            error: false,
            loading: false,
            infoType: 'save',
            disabledFields: false,
            responseError: null,
            OK: false,
            ERROR: false,
        }
    },
    created() {
        this.itemName = this.item.name;
    },
    computed: {
        isValidForm() {
            return this.item?.name ? this.item.name.length > 0 : false;
        },
    },
    methods: {
        getFormData() {
            return {
                displayId: this.item.id,
                settings: this.form,
            };
        },
        predictionsOff() {
            const itemId = this.item.id
            if (!itemId) {
                return;
            }
            this.loading = true;
            const groupParameters = {
                displayGroupId: itemId,
                settings: {
                    "DISPLAY_REALTIME_DATA_ENABLED": "0"
                }
            }
            this.$store.dispatch('deviceGroup/saveParametersForDisplayGroup', groupParameters)
                .then(response => {
                    this.OK = response.status == 200;
                })
                .catch(() => { this.ERROR = this.response.errorCode == 500; })
                .finally(() => { this.loading = false; });
        },

        predictionsOn() {
            const itemId = this.item.id
            if (!itemId) {
                return;
            }
            const groupParameters = {
                displayGroupId: itemId,
                settings: {
                    "DISPLAY_REALTIME_DATA_ENABLED": "1"
                }
            }
            this.$store.dispatch('deviceGroup/saveParametersForDisplayGroup', groupParameters)
                .then(response => {
                    this.OK = response.status == 200;
                })
                .catch(() => { this.ERROR = this.response.errorCode == 500; })
                .finally(() => { this.loading = false; });
        },
        displaysOff() {
            this.loading = true;
            const itemId = this.item.id
            if (!itemId) {
                return;
            }
            const groupParameters = {
                displayGroupId: itemId,
                settings: {
                    "DISPLAY_STATE": "0"
                }
            }
            this.$store.dispatch('deviceGroup/saveParametersForDisplayGroup', groupParameters)
                .then(response => {
                    this.OK = response.status == 200;
                })
                .catch(() => { this.ERROR = this.response.errorCode == 500; })
                .finally(() => { this.loading = false; });
        },
        displaysOn() {
            this.loading = true;
            const itemId = this.item.id
            if (!itemId) {
                return;
            }
            const groupParameters = {
                displayGroupId: itemId,
                settings: {
                    "DISPLAY_STATE": "1"
                }
            }
            this.$store.dispatch('deviceGroup/saveParametersForDisplayGroup', groupParameters)
                .then(response => {
                    this.OK = response.status == 200;
                })
                .catch(() => { this.ERROR = this.response.errorCode == 500; })
                .finally(() => { this.loading = false; });
        },
        announcementsOnlyOn() {
            this.loading = true;
            const itemId = this.item.id
            if (!itemId) {
                return;
            }
            const groupParameters = {
                displayGroupId: itemId,
                settings: {
                    "DISPLAY_STATE": "2"
                }
            }
            this.$store.dispatch('deviceGroup/saveParametersForDisplayGroup', groupParameters)
                .then(response => {
                    this.OK = response.status == 200;
                })
                .catch(() => { this.ERROR = this.response.errorCode == 500; })
                .finally(() => { this.loading = false; });

        },
        normalMode() {
            this.loading = true;
            const itemId = this.item.id
            if (!itemId) {
                return;
            }
            const groupParameters = {
                displayGroupId: itemId,
                settings: {
                    "DISPLAY_REALTIME_DATA_ENABLED": "1",
                    "DISPLAY_STATE": "1"
                }
            }
            this.$store.dispatch('deviceGroup/saveParametersForDisplayGroup', groupParameters)
                .then(response => {
                    this.OK = response.status == 200;
                })
                .catch(() => { this.ERROR = this.response.errorCode == 500; })
                .finally(() => { this.loading = false; });
        },
        sendAnnouncementsToTimetables() {
            this.loading = true;
            const itemId = this.item.id
            if (!itemId) {
                return;
            }
            this.$store.dispatch('deviceGroup/sendAnnouncementsToGroup', itemId)
                .then(response => {
                    this.OK = response.status == 200;
                })
                .catch(() => { this.ERROR = true; })
                .finally(() => { this.loading = false; });
        }
    },
}
</script>
<style lang="scss">
.flex-container {
    display: flex;
    flex-direction: row;
    margin: auto;
    flex-direction: column;
    align-items: center;
    font-size: 30;


    .flex-child {
        flex: 1;
        font-size: 30;
        width: 300px !important;
    }
}
</style>